export const booleanToRadioValue = (boolean?: boolean | null) => {
  return boolean ? "1" : "0";
};
